import { useParams } from "react-router-dom";

//Components
import FinanceClaniceRealiziranoCardItem from "./FinanceClaniceRealiziranoCardItem";

//API calls
import { useGetRealiziraneVrednostiProjektaClanice } from "../../../../services/ProjectDetails/financeAPI";

const FinanceClaniceRealiziranoCards = () => {
  const { id } = useParams();
  const { data: realiziraneVrednostiClanic = [], isLoading } =
    useGetRealiziraneVrednostiProjektaClanice(id);

  if (isLoading) {
    return (
      <div className="mb-3 mt-3">
        <h6 className="form-section-heading">
          Podatki ki se nanašajo na članice UM
        </h6>
        <p>Nalaganje realiziranih finančnih podatkov članic...</p>
      </div>
    );
  }

  return (
    <div>
      <h6 className="form-section-heading">
        Podatki ki se nanašajo na članice UM
      </h6>
      {realiziraneVrednostiClanic.map((clanica) => (
        <FinanceClaniceRealiziranoCardItem
          key={clanica.clanicaID}
          clanica={clanica}
        />
      ))}
    </div>
  );
};

export default FinanceClaniceRealiziranoCards;
